import {Injectable, signal} from '@angular/core';
import {TechnicalConclusionFile} from "../types/technical-conclusion-types";

@Injectable({
  providedIn: 'root'
})
export class TechnicalConclusionFilesStateService {
  private _technicalConclusionFilesState = signal<Record<number, Array<TechnicalConclusionFile>>>({});
  public technicalConclusionFilesState = this._technicalConclusionFilesState.asReadonly();

  public setTechnicalConclusionFilesState(id: number, technicalConclusionFiles: Array<TechnicalConclusionFile>): void {
    this._technicalConclusionFilesState.set({
      ...this._technicalConclusionFilesState(),
      [id]: technicalConclusionFiles
    });
  }

  public getTechnicalConclusionFilesById(id: number): Array<TechnicalConclusionFile> {
    return this.technicalConclusionFilesState()[id];
  }

  public deleteFileById(fileId: number, technicalConclusionId: number): void {
    this._technicalConclusionFilesState.update(state => {
      const currentFiles = state[technicalConclusionId] || [];
      const updatedFiles = currentFiles.filter(file => file.id !== fileId);

      return {
        ...state,
        [technicalConclusionId]: updatedFiles
      };
    });
  }

  public updateTechnicalConclusionFilesState(technicalConclusionId: number, technicalConclusionFile: TechnicalConclusionFile): void {
    this._technicalConclusionFilesState.update(state => {
      const currentFiles = state[technicalConclusionId] || [];
      const updatedFiles = [...currentFiles, technicalConclusionFile];

      return {
        ...state,
        [technicalConclusionId]: updatedFiles
      };
    });
  }

  public deleteTechnicalConclusionFilesState(technicalConclusionId: number): void {
    this._technicalConclusionFilesState.update(state => {
      const newState = { ...state };
      delete newState[technicalConclusionId];
      return newState;
    });
  }
}
